import { render, staticRenderFns } from "./WelcomeHeader.vue?vue&type=template&id=b30059bc&"
import script from "./WelcomeHeader.vue?vue&type=script&lang=js&"
export * from "./WelcomeHeader.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports